import { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ResourcesHero from "../components/resources/ResourcesHero";
import ResourcesCategories from "../components/resources/ResourcesCategories";
import ResourcesFeatured from "../components/resources/ResourcesFeatured";
import ResourcesContact from "../components/resources/ResourcesContact";
import { getAllCategories } from "../../data/resources";

function ResourcesPage() {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const categories = getAllCategories();

  return (
    <div className="min-h-screen relative">
      {/* Background */}
      <div className="fixed inset-0 w-full h-full overflow-hidden z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-white via-[#fff5eb] to-[#f9f6f4]"></div>
        
        {/* Grid pattern background */}
        <svg className="absolute inset-0 w-full h-full opacity-[0.07]" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M0 10 L40 10" stroke="#946e5d" strokeWidth="0.5" fill="none" />
              <path d="M0 20 L40 20" stroke="#946e5d" strokeWidth="0.5" fill="none" />
              <path d="M0 30 L40 30" stroke="#946e5d" strokeWidth="0.5" fill="none" />
              <path d="M10 0 L10 40" stroke="#946e5d" strokeWidth="0.5" fill="none" />
              <path d="M20 0 L20 40" stroke="#946e5d" strokeWidth="0.5" fill="none" />
              <path d="M30 0 L30 40" stroke="#946e5d" strokeWidth="0.5" fill="none" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>
      
      {/* Main Content */}
      <div className="relative z-10">
        <Header />
        
        <main>
          {/* Hero Section with Search */}
          <ResourcesHero />
          
          {/* Featured Articles */}
          <ResourcesFeatured />
          
          {/* Resource Categories */}
          <ResourcesCategories categories={categories} />
          
          {/* Contact Support */}
          <ResourcesContact />
        </main>
        
        <Footer />
      </div>
    </div>
  );
}

export default ResourcesPage;